import type { FieldValues, Path } from 'react-hook-form';
import { cn } from '@lqa-frontend/ui-system';
import { startCase } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormDescription, FormField, FormItem, FormLabel } from './Form';
import type { ITabSolidOption, TabSolidIconPosition } from '../tab-solid';
import { TabSolid } from '../tab-solid';

export function TabsSolidFormField<T extends FieldValues>(
	props: ITabsSolidFormFieldProps<T>
) {
	const form = useFormContext();

	const tabOptions: ITabSolidOption[] = props.options.map((option) => {
		if (typeof option === 'string') {
			return {
				label: startCase(option),
				value: option,
				isDisabled: props.disabled,
			};
		}
		return {
			label:
				typeof option.label === 'string' ? option.label : String(option.label),
			value: String(option.value),
			icon: option.icon,
			isDisabled: props.disabled,
		};
	});

	return (
		<FormField
			control={form.control}
			name={props.name}
			render={({ field }) => (
				<FormItem className={cn('w-full', props.itemClassName)}>
					<div className="flex flex-col gap-4">
						{props.label ? <FormLabel>{props.label}</FormLabel> : ''}
						{props.description ? (
							<FormDescription>{props.description}</FormDescription>
						) : (
							''
						)}
					</div>
					<TabSolid
						options={tabOptions}
						value={field.value}
						onValueChange={field.onChange}
						className={props.className}
						listClassName="w-full"
						triggerClassName="w-full"
						iconPosition={props.iconPosition}
					/>
				</FormItem>
			)}
		/>
	);
}

interface ITabsSolidFormFieldProps<T extends FieldValues> {
	name: Path<T>;
	label?: string | React.ReactNode;
	description?: string;
	options:
		| {
				value: string | number | boolean;
				label: string | React.ReactNode;
				icon?: React.ReactNode;
		  }[]
		| string[];
	disabled?: boolean;
	itemClassName?: string;
	className?: string;
	iconPosition?: TabSolidIconPosition;
}
